import {SUPPORTED_MENU_PLATFORMS} from './constants';

export const MENU_ROUTE_BASE_PATHS = {
	RAYQUAZA: '/menu',
	HANGRY_APP: '/menu/hangry-app',
};

const getCurrentPathname = () => (
	typeof window === 'undefined' ? MENU_ROUTE_BASE_PATHS.RAYQUAZA : window.location.pathname
);

export const isHangryAppMenuPath = (pathname = getCurrentPathname()) => (
	pathname === MENU_ROUTE_BASE_PATHS.HANGRY_APP || pathname.startsWith(`${MENU_ROUTE_BASE_PATHS.HANGRY_APP}/`)
);

export const getMenuRouteBasePath = (pathname = getCurrentPathname()) => (
	isHangryAppMenuPath(pathname) ? MENU_ROUTE_BASE_PATHS.HANGRY_APP : MENU_ROUTE_BASE_PATHS.RAYQUAZA
);

export const getMenuAvailabilityMode = (pathname = getCurrentPathname()) => (
	isHangryAppMenuPath(pathname) ? 'hangry-app' : 'rayquaza'
);

export const getMenuAvailabilityPlatforms = (pathname = getCurrentPathname()) => (
	isHangryAppMenuPath(pathname)
		? [SUPPORTED_MENU_PLATFORMS.HANGRY_APP]
		: [SUPPORTED_MENU_PLATFORMS.GRAB, SUPPORTED_MENU_PLATFORMS.GOJEK, SUPPORTED_MENU_PLATFORMS.SHOPEEE]
);

export const filterMenuAvailabilityRows = (rows = [], platformLabels = getMenuAvailabilityPlatforms()) => {
	const allowedPlatforms = new Set(platformLabels);
	return rows
		.map(row => ({
			...row,
			platformList: (row.platformList || []).filter(platform => allowedPlatforms.has(platform.platformLabel)),
		}))
		.filter(row => row.platformList.length > 0);
};

export const filterMaterialMenuGroups = (groups = {}, platformLabels = getMenuAvailabilityPlatforms()) => {
	const allowedPlatforms = new Set(platformLabels);
	const filterItems = items => items
		.map(item => {
			if (!item || typeof item !== 'object') return item;
			if (Array.isArray(item.platformList)) {
				return {
					...item,
					platformList: item.platformList.filter(platform => allowedPlatforms.has(platform.platformLabel)),
				};
			}
			const platformLabel = item.platformLabel || item.platform;
			return platformLabel && !allowedPlatforms.has(platformLabel) ? null : item;
		})
		.filter(item => item && (!Array.isArray(item.platformList) || item.platformList.length > 0));

	return Object.fromEntries(Object.entries(groups || {}).map(([key, group]) => {
		if (!group || typeof group !== 'object') return [key, group];
		return [key, {
			...group,
			...(Array.isArray(group.menus) && {menus: filterItems(group.menus)}),
			...(Array.isArray(group.childMenus) && {childMenus: filterItems(group.childMenus)}),
		}];
	}));
};
